"use client";
import { Suspense } from "react";
import { PostPreview, PostView } from "../article-card";
import { PostsFilterBar } from "./filter-bar";
import { usePostsFilter } from "./use-posts-filter";
import { LoadingArea } from "@ui/loading";

interface PostsFilterBarWithHookProps {
  posts: PostPreview[];
  sortedPosts: PostPreview[];
}

const PostsFilterBarAndPostView = ({
  posts,
  sortedPosts,
}: PostsFilterBarWithHookProps) => {
  const {
    selectedPosts,
    onFilterChange,
    onSearchChange,
    onSortChange,
    filterOptions,
    sortOptions,
  } = usePostsFilter({ posts }, "knowledge-center");
  return (
    <>
      <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
        <PostsFilterBar
          {...{
            selectedPosts,
            onFilterChange,
            onSearchChange,
            onSortChange,
            filterOptions,
            sortOptions,
            buttonColors: [
              "#3B82F6",
              "#29A4B2",
              "#F97316",
              "#22C55E",
              "#BF82FF",
              "#7A7DF3",
            ],
            from: "knowledge-center",
          }}
        />
      </Suspense>
      <PostView
        posts={sortedPosts}
        {...{
          isHome: true,
          filtered: selectedPosts,
        }}
        tag={false}
        color="black"
      />
    </>
  );
};

export default PostsFilterBarAndPostView;
